import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { addCareerAdviceAdmin, deleteCareerAdviceAdmin, fetchCareerAdviceAdmin, updateCareerAdviceAdmin } from "./CarrerAdviceAdminAPI";

export const fetchCareerAdviceAdminasync = createAsyncThunk(
    "careerAdviceAdmin/fetch",
    async (_, { rejectWithValue }) => {
        try {
            return await fetchCareerAdviceAdmin();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const addCareerAdviceAdminAsync = createAsyncThunk(
    "careerAdviceAdmin/add",
    async (newItem, { rejectWithValue }) => {
        try {
            return await addCareerAdviceAdmin(newItem);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// UPDATED: accept { uuid, data } and support FormData (handled in API via POST + _method=PUT)
export const updateCareerAdviceAdminAsync = createAsyncThunk(
    "careerAdviceAdmin/update",
    async ({ uuid, data }, { rejectWithValue }) => {
        try {
            return await updateCareerAdviceAdmin(uuid, data);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteCareerAdviceAdminAsync = createAsyncThunk(
    "careerAdviceAdmin/delete",
    async (uuid, { rejectWithValue }) => {
        try {
            return await deleteCareerAdviceAdmin(uuid);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const CareerAdviceAdminSlice = createSlice({
    name: "careerAdviceAdmin",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchCareerAdviceAdminasync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCareerAdviceAdminasync.fulfilled, (state, action) => {
                state.loading = false;
                state.data =
                    action.payload?.response ??
                    action.payload?.data?.response ??
                    [];
            })
            .addCase(fetchCareerAdviceAdminasync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Add
            .addCase(addCareerAdviceAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(addCareerAdviceAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const server = action.payload?.response ?? action.payload?.data ?? null;
                if (!server) return;
                if (Array.isArray(server)) state.data.unshift(...server);
                else state.data.unshift(server);
            })
            .addCase(addCareerAdviceAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update
            .addCase(updateCareerAdviceAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateCareerAdviceAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const { uuid, data: patch } = action.meta.arg;
                const server = action.payload?.response ?? action.payload?.data ?? null;

                const idx = state.data.findIndex((i) => i?.uuid === uuid || i?.id === uuid);
                if (idx === -1) return;

                if (server && (server.uuid || server.id)) {
                    state.data[idx] = server;
                } else {
                    const canPatch = patch && !(typeof FormData !== "undefined" && patch instanceof FormData);
                    if (canPatch) {
                        state.data[idx] = { ...state.data[idx], ...patch };
                    }
                }
            })
            .addCase(updateCareerAdviceAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Delete
            .addCase(deleteCareerAdviceAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteCareerAdviceAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const uuid = action.meta.arg;
                state.data = state.data.filter((item) => item.uuid !== uuid && item.id !== uuid);
            })
            .addCase(deleteCareerAdviceAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectCareerAdviceAdmin = (state) =>
    state.careerAdviceAdmin.data;
export const selectCareerAdviceAdminLoading = (state) =>
    state.careerAdviceAdmin.loading;

export default CareerAdviceAdminSlice.reducer;